module.exports = __webpack_public_path__ + "static/img/mob-7.555d70c3.png";